export enum VendorActionTypes {
    API_RESPONSE_SUCCESS = '@@vendor/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@vendor/API_RESPONSE_ERROR',

    GET_VENDORS = '@@vendor/GET_VENDORS',
    GET_VENDOR_BY_ID = '@@vendor/GET_VENDOR_BY_ID',
    ADD_VENDOR = '@@vendor/ADD_VENDOR',
    UPDATE_VENDOR = '@@vendor/UPDATE_VENDOR',
    DELETE_VENDOR = '@@vendor/DELETE_VENDOR',

    BULK_IMPORT_VENDORS = '@@vendor/BULK_IMPORT_VENDORS',
    RESET_IMPORT_STATE = '@@vendor/RESET_IMPORT_STATE',

    RESET = '@@vendor/RESET',
}